import React, { FC, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Infos from '../../components/infos/infos';
import SubmitButton from '../../components/submit-button/submit-button';
import { deleteAnnouncement, backofficeRecipientsToEngagementRows } from '../../helpers/announcement-helper';
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerBiggerSide,
  BaseContentContainerFormat,
} from '../../models/base-content-container';
import { GeneralContext } from '../../providers/general-provider';
import AnnouncementService from '../../services/announcement-service';

const AnnouncementFollow: FC<{
  announcement: BackofficeAnnouncementDetailDto;
  announcementService: AnnouncementService;
}> = ({ announcement, announcementService }) => {
  const navigate = useNavigate();
  const { announcementId } = useParams<{ announcementId: string }>();
  const { setModalContent, setToastContent } = useContext(GeneralContext);

  const announcementData: (InfosData | InfosDataAttachments)[] = [
    {
      type: 'title',
      content: announcement.title,
    },
    {
      type: 'image',
      content: announcement.image?.url || null,
    },
    {
      type: 'text',
      content: announcement.description,
    },
    {
      type: 'attachments',
      content: announcement.attachments.map((attachment) => ({
        location: attachment.url,
        originalName: attachment.name,
      })),
    },
  ];

  // A nova API só devolve o status "lido" por destinatário (sem a distinção
  // "visualizado" x "lido" que existia antes), então a tabela de engajamento
  // fica com uma única coluna de status.
  const engagementData: InfosDataList = {
    type: 'list',
    content: {
      titles: [
        { text: 'Aluno' },
        { text: 'Turma' },
        { text: 'Responsável' },
        { text: 'Lido', customStyle: { textAlign: 'center' } },
      ],
      rows: backofficeRecipientsToEngagementRows(announcement.recipients),
    },
  };

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.doubleWithActionButtons}
      withoutShadowBox={true}
      biggerSide={BaseContentContainerBiggerSide.right}
      actionButtonPosition={BaseContentContainerActionButtonPosition.bottom}
    >
      <Infos
        title='comunicado enviado'
        titleColor='intermediate'
        data={announcementData}
      />
      <Infos
        title='engajamento'
        titleColor='curiosity'
        backgroundColor='gray'
        data={engagementData}
      />
      <ButtonsBar pattern='firstSeparate' verticalAlign='bottom'>
        <Link to='/comunicados/listar'>
          <SubmitButton value='cancelar' variant='terciary' />
        </Link>
        <SubmitButton
          value='deletar'
          variant='terciary'
          onClick={() =>
            deleteAnnouncement(
              announcementService,
              announcementId,
              setModalContent,
              setToastContent,
              navigate
            )
          }
        />
      </ButtonsBar>
    </BaseContentContainer>
  );
};

export default AnnouncementFollow;
